import { createGlobalStyle } from 'antd-style'

import {
  ANT_THEME_BULK_PAGE_PREFIX,
  ANT_THEME_DASHBOARD_PREFIX,
  ANT_THEME_PREFIX,
  ANT_THEME_TELEMEDICINE_CALL
} from '../config'

// FIXME styled
const GlobalStyle = createGlobalStyle`
  .${ANT_THEME_PREFIX}-tabs {
      overflow: inherit !important;
  }
  .${ANT_THEME_BULK_PAGE_PREFIX},
  .${ANT_THEME_DASHBOARD_PREFIX},
  .${ANT_THEME_TELEMEDICINE_CALL},
  .${ANT_THEME_PREFIX} {
    &-form-item-label {
      text-transform: uppercase;
        font-weight: 500;
    }

    &-table-thead {
      .${ANT_THEME_BULK_PAGE_PREFIX},
      .${ANT_THEME_DASHBOARD_PREFIX},
      .${ANT_THEME_PREFIX} {
        &-table-cell {
          text-transform: uppercase;
          font-size: 9px;
        }
      }
    }
  }
  .${ANT_THEME_TELEMEDICINE_CALL} {
    &-form-item label.${ANT_THEME_TELEMEDICINE_CALL}-checkbox-wrapper {
      display: flex;
      align-items: center;
      span:last-child {
        line-height: 1;
      }
    }
    &-form-item.switch-padding label {
      padding-top: 2px;
    }
  }

  .${ANT_THEME_BULK_PAGE_PREFIX} {
    &-btn {
      text-transform: uppercase;
    }

    &-card.settings-card {
      margin-bottom: 10px;
      width: 50%;

      .settings-table-wrapper {
        border: 1px solid #DDE2EC;
        border-radius: 4px;
        height: 450px;
        overflow: auto;
        padding: 0px 5px;
      }
    }
    
    &-divider {
      margin: 5px 0;
    }

    &-picker {
      width: 100%;
    }

    &-table-wrapper {
      .row {
        &-active {
          background-color: #EEF2FB;
        }
  
        &-expanded {
          background-color: #CECECF;
        }
      }

      .bulk-page-table-cell.actions {
        vertical-align: top;
      }
    }

    &-typography.settings-title {
      color: #577DDB;
    }
  }
`
export default GlobalStyle
